// A wrapper around date.now to make saga testing easier
export function getNow() {
    return Date.now();
}
//# sourceMappingURL=utils.js.map